import { defineComponent, computed, createElementBlock, openBlock, normalizeClass, createElementVNode, createVNode, createCommentVNode, toDisplayString, Fragment, renderList, createBlock, unref, withCtx } from 'vue';
import { Vue3Marquee } from './basler-components.es358.js';
import _sfc_main$1 from './basler-components.es11.js';
/* empty css                       */
import _sfc_main$2 from './basler-components.es117.js';
/* empty css                        */

const _hoisted_1 = { class: "solution-tag-cloud__background" };
const _hoisted_2 = { class: "solution-tag-cloud__foreground" };
const _hoisted_3 = { class: "solution-tag-cloud__title" };
const _hoisted_4 = { class: "solution-tag-cloud__text" };
const _hoisted_5 = {
  key: 0,
  class: "solution-tag-cloud__tags"
};
const _hoisted_6 = {
  key: 1,
  class: "solution-tag-cloud__tags-marquee"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "SolutionTagCloudBlock",
  props: {
    headline: {},
    text: {},
    tags: {},
    marqueeMode: { default: "disabled" },
    marqueeLines: {}
  },
  setup(__props) {
    const props = __props;
    const marqueeLinesTags = computed(() => {
      if (props.marqueeLines == null || props.marqueeLines < 1) {
        return props.tags;
      }
      const dividedArrays = [];
      const arr = props.tags;
      const chunkSize = Math.ceil(arr.length / props.marqueeLines);
      for (let i = 0; i < arr.length; i += chunkSize) {
        dividedArrays.push(arr.slice(i, i + chunkSize));
      }
      return dividedArrays;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["solution-tag-cloud", `solution-tag-cloud--marquee-${_ctx.marqueeMode}`])
      }, [
        createElementVNode("div", _hoisted_1, [
          createVNode(_sfc_main$1)
        ]),
        createElementVNode("div", _hoisted_2, [
          createElementVNode("h2", _hoisted_3, toDisplayString(props.headline), 1),
          createElementVNode("p", _hoisted_4, toDisplayString(props.text), 1),
          _ctx.marqueeMode !== "all" ? (openBlock(), createElementBlock("div", _hoisted_5, [
            createVNode(_sfc_main$2, {
              tags: props.tags,
              alignment: "center"
            }, null, 8, ["tags"])
          ])) : createCommentVNode("", true),
          _ctx.marqueeMode !== "disabled" && _ctx.marqueeLines != null && _ctx.marqueeLines >= 1 ? (openBlock(), createElementBlock("div", _hoisted_6, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(marqueeLinesTags.value, (item, index) => {
              return openBlock(), createElementBlock("div", {
                class: "solution-tag-cloud__tags-line",
                key: index
              }, [
                (openBlock(), createBlock(unref(Vue3Marquee), {
                  duration: 60,
                  "pause-on-hover": true,
                  key: index
                }, {
                  default: withCtx(() => [
                    createVNode(_sfc_main$2, {
                      tags: item,
                      "is-not-wrapped": true
                    }, null, 8, ["tags"])
                  ]),
                  _: 2
                }, 1024))
              ]);
            }), 128))
          ])) : createCommentVNode("", true)
        ])
      ], 2);
    };
  }
});

export { _sfc_main as default };
